/* SALSHOPIFY-342 フッターメニュー SP表示アコーディオン */
(function () {
  if (window.c_footer_accordion_ready) {
    return;
  }
  window.c_footer_accordion_ready = true;

  var mobile = window.matchMedia('(max-width: 749px)');

  function setOpen(item, open) {
    var toggle = item.querySelector('.c_footer-accordion__toggle');
    item.classList.toggle('is-open', open);
    if (toggle) {
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
  }

  // PCは常時展開のためボタンをフォーカス対象外にし、aria-expanded も展開扱いにする
  function sync() {
    document.querySelectorAll('.c_footer-accordion').forEach(function (item) {
      var toggle = item.querySelector('.c_footer-accordion__toggle');
      if (!toggle) {
        return;
      }
      if (mobile.matches) {
        toggle.removeAttribute('tabindex');
        toggle.setAttribute('aria-expanded', item.classList.contains('is-open') ? 'true' : 'false');
      } else {
        toggle.setAttribute('tabindex', '-1');
        toggle.setAttribute('aria-expanded', 'true');
      }
    });
  }

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('.c_footer-accordion__toggle');
    if (!toggle || !mobile.matches) {
      return;
    }
    var item = toggle.closest('.c_footer-accordion');
    setOpen(item, !item.classList.contains('is-open'));
  });

  mobile.addEventListener('change', sync);

  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', sync);
    // テーマエディタでブロック選択時に中身を確認できるよう開く
    document.addEventListener('shopify:block:select', function (event) {
      if (event.target.classList.contains('c_footer-accordion')) {
        setOpen(event.target, true);
      }
    });
  }

  sync();
})();
